<template>
    <figure class="ds-display-flex ds-flex-direction-column">
        <template v-if="captionPosition === 'bottom'">
            <slot>
                <img v-if="image" :src="image.src" :alt="image.name" class="ds-margin-bottom-24" data-j-figure-top />
            </slot>
        </template>
        <figcaption>
            <p class="ds-text-small ds-color-green ds-margin-bottom-3" data-j-title>
                {{ captionTitle }}
            </p>
            <p class="ds-text-small" :class="[ theme === 'dark' ? 'ds-color-white' : 'ds-color-grey-450' ]" data-j-text>
                {{ captionText }}
            </p>
        </figcaption>
        <template v-if="captionPosition === 'top'">
            <slot>
                <img v-if="image" :src="image.src" :alt="image.name" class="ds-margin-top-24" data-j-figure-bottom />
            </slot>
        </template>
    </figure>
</template>

<script>
/**
 * Figure element
 *
 * @example
 * ```js
 * import { DsFigureElement } from '../../atoms';
 *
 * export default {
 *   components: { DsFigureElement },
 *   template: `
 *     <DsFigureElement
 *       :captionTitle="title"
 *       :captionText="text"
 *     </DsFigureElement>
 * `};
 * ```
 */

import { theme } from '../../utils/mixins';

export default {
    name: 'DsFigureElement',
    mixins: [theme],
    props: {
        /**
         * Caption Title
         */
        captionTitle: { type: String, required: true },
        /**
         * Caption text
         */
        captionText: { type: String, required: true },
        /**
         * Position of caption in relation the figure
         */
        captionPosition: {
            type: String,
            default: 'bottom',
            validator: value => ['bottom', 'top'].includes(value)
        },
        /**
         * Image
         * @property {Object} image.small - { src: String, name: String }
         * @property {Object} image.medium - { src: String, name: String }
         * @property {Object} image.large - { src: String, name: String }
         */
        image: {
            type: Object,
            default: null,
            validator: obj => ['src', 'name'].every(key => key in obj)
        }
    }
};
</script>
